/* eslint-disable consistent-return */
import API from 'utils/api';
import { store } from 'store';
import { getEmpresaCaja } from 'api/empresas';
import { getPredioCaja } from 'api/catastro';
import { getVehiculoCaja } from 'api/recaudacion';
import { getHospedajeCaja } from 'api/empresas/hospedajes';
import { getArrendamientoCaja } from 'api/empresas/arrendamientos';
import { getNominaCaja } from 'api/empresas/nomina';
import { getAlcoholCaja } from 'api/empresas/alcoholes';
import { getCedulaCaja } from 'api/empresas/cedulas';
import { getJuegosDeAzarCaja } from 'api/empresas/juegosDeAzar';
import { getNotariosCaja } from 'api/empresas/notarios';
import { getCasasDeEmpenioCaja } from 'api/empresas/casasDeEmpenio';
import { getAgenciasCaja } from 'api/empresas/agencias';
import { getContribuyenteCaja } from 'api/empresas/contribuyentes';
import { getMotocicletaCaja } from 'api/recaudacion/motocicletas';
import { getRemolqueCaja } from 'api/recaudacion/remolque';
import { getContratosDePoliciasCaja } from 'api/empresas/contratosDePolicias';
import { getInfraccionesCaja } from 'api/recaudacion/infracciones';
import { getExpedientesDeComercioCaja } from 'api/empresas/expedienteDeComercioInformal';
import { getExpedientesDeMercadoCaja } from 'api/empresas/expedienteDeMercado';
import { getExpedienteDeLicenciaCaja } from 'api/empresas/expedienteDeLicenciaDeFuncionamiento';
import { getZonasExclusivasCaja } from 'api/empresas/zonasExclusivas';
import { getExpedienteDeAnunciosCaja } from 'api/empresas/expedienteDeAnuncios';
import { getMultasCaja } from 'api/recaudacion/multas';
import { getVendedorDeAlcoholesCaja } from 'api/empresas/ventaDeAlcoholes';
import { getRetenedorDeCedulaCaja } from 'api/empresas/retenedorDeCedulas';
import { getRetenedorDeNominaCaja } from 'api/empresas/retenedorDeNomina';
import { getEstacionamientoCaja } from 'api/empresas/estacionamientos';
import { getCiudadanoCaja } from 'api/cuentaunicasir/index';
import { getPanteonesCaja } from 'api/empresas/panteones';
import { getExpedienteDeModulosCaja } from 'api/empresas/modulos';
// import { selectContentTypesPadrones } from 'store/catalogos';

const descriptionsMap = {
  4: 'Vehículo',
  11: 'Juegos de Azar',
  13: 'Casa de empeño',
};

/**
 * GET Tipos de Padrones
 * @param {func} dispatch
 * @returns {Promise<object[]>}
 */
export const getPadrones = async () => {
  try {
    const response = await API.get('catalogos/padrones');
    const mapped = response.data.filter((e) => e.id !== 5).map((e) => ({
      ...e,
      descripcion: descriptionsMap[e.id] || e.descripcion,
    }));
    return mapped;
  } catch (error) {
    return [];
  }
};

export const getPadron = async (id) => {
  try {
    const response = await API.get('catalogos/padrones', {
      params: { id },
    });
    const { data } = response;
    if (Array.isArray(data)) {
      return data[0] || null;
    }
    return data;
  } catch (error) {
    return null;
  }
};

/**
 * GET Búsqueda en Padrón Ciudadanos
 * @param {object} params
 * @param {string} params.q
 * @param {boolean} useRegisterMessage
 * @returns {Promise<object[]>}
 */
// eslint-disable-next-line consistent-return
export const getCiudadano = async (params = false) => {
  try {
    const response = await API.get('cuentaunicasir/ciudadano-caja-public', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Empresa
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
// eslint-disable-next-line consistent-return
export const getEmpresa = async (params) => {
  try {
    const response = await API.get('cuentaunicasir/empresas-caja-atencion-ciudadana/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Predio
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getPredio = async (params) => {
  try {
    const response = await API.get('cuentaunicasir/predio-caja-atencion-ciudadana/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Vehiculo
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getVehiculo = async (params) => {
  try {
    const response = await API.get('cuentaunicasir/vehiculos-caja-atencion-ciudadana', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Hospedaje
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getHospedaje = async (params) => {
  try {
    const response = await API.get('empresas/hospedaje-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Arrendamiento
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getArrendamiento = async (params) => {
  try {
    const response = await API.get('empresas/arrendamiento-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Nomina
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getNomina = async (params) => {
  try {
    const response = await API.get('empresas/nomina-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Alcohol
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getAlcohol = async (params) => {
  try {
    const response = await API.get('empresas/alcohol-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Cedular
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getCedular = async (params) => {
  try {
    const response = await API.get('empresas/cedular-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Juegos de Azar
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getJuegoDeAzar = async (params) => {
  try {
    const response = await API.get('empresas/juego-de-azar-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Notario
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getNotario = async (params) => {
  try {
    const response = await API.get('empresas/notario-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Caja de Empeño
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getCasaDeEmpenio = async (params) => {
  try {
    const response = await API.get('/empresas/casa-de-impenio-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Agencia
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getAgencia = async (params) => {
  try {
    const response = await API.get('empresas/agencia-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Contribuyente
 * @param {object} params
 * @param {string} params.q
 * @param {boolean} useRegisterMessage
 * @returns {Promise<object[]>}
 */
// eslint-disable-next-line consistent-return
export const getContribuyente = async (params) => {
  try {
    const response = await API.get('empresas/contribuyentes-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Padrón Motocicleta
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getMotocicleta = async (params) => {
  try {
    const response = await API.get('recaudacion/motocicletas-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Remolque
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getRemolque = async (params) => {
  try {
    const response = await API.get('recaudacion/remolques-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Policias Especiales
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getPoliciaEspecial = async (params) => {
  try {
    const response = await API.get('empresas/contratos-de-policias-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Infracciones
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getInfracciones = async (params) => {
  try {
    const response = await API.get('recaudacion/infracciones-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Expediente de licencia de comercio
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getExpedienteDeComercio = async (params) => {
  try {
    const response = await API.get('empresas/expedientes-de-comercio-informal-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Expediente de mercado
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getExpedienteDeMercado = async (params) => {
  try {
    const response = await API.get('empresas/expedientes-de-mercados-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Expediente de licencia de funcionamiento
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getExpedienteDeLicencia = async (params) => {
  try {
    const response = await API.get('empresas/expedientes-de-licencias-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Zonas exclusivas
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getZonaExclusiva = async (params) => {
  try {
    const response = await API.get('empresas/zonas-exclusivas-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

/**
 * GET Búsqueda en Expediente de Anuncios
 * @param {object} params
 * @param {string} params.q
 * @returns {Promise<object[]>}
 */
export const getExpedienteDeAnuncio = async (params) => {
  try {
    const response = await API.get('empresas/expedientes-de-anuncios-caja-public/', { params });
    return response.data[0];
  } catch (error) {
    return [];
  }
};

export const getTipoDePadronPorContenType = (contentTypeId) => {
  const contentType = store.getState()
    .catalogs.contentTypesPadrones.find((p) => p.id === contentTypeId);
  return store
    .getState().catalogs.padrones.find((p) => p.id === contentType?.nivel)?.id;
};

export const getContenTypePorTipoDePadron = (tipoDePadronId) => store
  .getState().catalogs.contentTypesPadrones.find((p) => p.nivel === tipoDePadronId)?.id;

const gettersMap = {
  1: (id) => getCiudadano(id),
  2: (id) => getEmpresa(id),
  3: (id) => getPredio(id),
  4: (id) => getVehiculo(id),
  6: (id) => getHospedaje(id),
  7: (id) => getArrendamiento(id),
  8: (id) => getNomina(id),
  9: (id) => getAlcohol(id),
  10: (id) => getCedular(id),
  11: (id) => getJuegoDeAzar(id),
  12: (id) => getNotario(id),
  13: (id) => getCasaDeEmpenio(id),
  14: (id) => getAgencia(id),
  15: (id) => getContribuyente(id),
  16: (id) => getMotocicleta(id),
  17: (id) => getRemolque(id),
  18: (id) => getPoliciaEspecial(id),
  19: (id) => getInfracciones(id),
  20: (id) => getExpedienteDeComercio(id),
  21: (id) => getExpedienteDeMercado(id),
  22: (id) => getExpedienteDeLicencia(id),
  23: (id) => getZonaExclusiva(id),
  24: (id) => getExpedienteDeAnuncio(id),
};

export const getHelpTexts = (id) => {
  const defaultText = 'Clave, descripción, RFC o correo';
  const defaultTextVehiculos = 'Número de Serie o Número de Placas';
  if (!id) return `Búsqueda por ${defaultText}`;
  const helpTexts = {
    1: 'Nombre, CURP o Clave Ciudadana',
    2: 'Razón Social, Nombre Comercial o RFC',
    3: 'Cuenta Única de Predial, CURT, Clave Catastral Estándar, No. Cuenta o Clave Sectorial',
    4: defaultTextVehiculos,
    16: defaultTextVehiculos,
    17: defaultTextVehiculos,
    19: 'Clave, Serie o Folio',
  };

  return `Búsqueda por ${helpTexts[id] || defaultText}`;
};

export const gettersPadronesCajaMap = {
  1: getCiudadanoCaja,
  2: getEmpresaCaja,
  3: getPredioCaja,
  4: getVehiculoCaja,
  6: getHospedajeCaja,
  7: getArrendamientoCaja,
  8: getNominaCaja,
  9: getAlcoholCaja,
  10: getCedulaCaja,
  11: getJuegosDeAzarCaja,
  12: getNotariosCaja,
  13: getCasasDeEmpenioCaja,
  14: getAgenciasCaja,
  15: getContribuyenteCaja,
  16: getMotocicletaCaja,
  17: getRemolqueCaja,
  18: getContratosDePoliciasCaja,
  19: getInfraccionesCaja,
  20: getExpedientesDeComercioCaja,
  21: getExpedientesDeMercadoCaja,
  22: getExpedienteDeLicenciaCaja,
  23: getZonasExclusivasCaja,
  24: getExpedienteDeAnunciosCaja,
  25: getMultasCaja,
  26: getVendedorDeAlcoholesCaja,
  27: getRetenedorDeCedulaCaja,
  28: getRetenedorDeNominaCaja,
  30: getEstacionamientoCaja,
  31: getPanteonesCaja,
  32: getExpedienteDeModulosCaja,
};

export default gettersMap;
